<template>
    <div class="sort-and-sections">
        <div class="sort-and-sections__container">
            <span class="text-size-s" v-html="text.sorting" />
            <z-link
                tag="button"
                :class="{'is-active': params.how === item.id}"
                class="sort-and-sections__link"
                :underlined="false"
                @click="onSortChange(item.id)"
                v-for="(item, index) in sortList"
                :key="index"
            >
                <span v-html="item.name"></span>
            </z-link>
        </div>
        <div v-if="sections && sections.length" class="sort-and-sections__container">
            <span class="text-size-s" v-html="text.section" />
            <z-link
                tag="button"
                v-for="(item, index) in sections"
                :class="{
                    'is-active': params.section === item.xmlId || item.xmlId === 'all' && params.section === '',
                    'is-disabled': +item.count === 0
                }"
                :key="`section-${index}`"
                :underlined="false"
                class="sort-and-sections__link"
                @click="onSectionChange(item.xmlId)"
            >
                {{ item.text }} <span class="text-size-xs">({{item.count}})</span>
            </z-link>
        </div>
    </div>
</template>

<script setup>
import { localize } from '@/utils/i18n'
import { ref, onBeforeMount } from 'vue'
import { text } from '../locales'

const props = defineProps({
    sections: {
        type: Array,
        default: () => []
    },
    initialParams: {
        type: Object,
        default: () => {}
    }
})

const sortList = [
    {
        id: 'r',
        name: localize({
            ru: 'По&nbsp;релевантности',
            en: 'Relevance',
            cn: 'Relevance'
        })
    },
    {
        id: 'd',
        name: localize({
            ru: 'По&nbsp;дате',
            en: 'By&nbsp;date',
            cn: 'By&nbsp;date'
        })
    }
]

const params = ref({
    how: 'r', // sort
    section: ''
})

const emit = defineEmits([
    'change',
    'clear'
])

const clear = () => {
    params.value = {
        how: 'r',
        section: ''
    }
    emit('clear', params.value)
}

const onSortChange = sort => {
    params.value.how = sort
    emit('change', params.value)
}

const onSectionChange = section => {
    params.value.section = section === 'all' ? '' : section
    emit('change', params.value)
}

defineExpose({
    clear
})

onBeforeMount (() => {
    for (const key in props.initialParams) {
        if (params.value.hasOwnProperty(key)) {
            params.value[key] = props.initialParams[key]
        }
    }

    params.value.section = props.sections.find(item => item.selected)?.xmlId || ''
})
</script>

<style lang="scss">

.sort-and-sections {
    &__container {
        display: flex;
        gap: 24px;
        flex-wrap: wrap;

        & + & {
            margin-top: 24px;
        }
    }

    &__link {
        position: relative;
        @include typo-level(S);

        &:before{
            content: '';
            position: absolute;
            left: 0;
            bottom: -3px;
            width: 0;
            height: 1px;
            background: currentColor;
            transition: width .3s ease-in-out;
        }

        &.is-active {
            pointer-events: none;

            &:before{
                width: 100%;
            }
        }
        &:hover{
            text-decoration: unset;

            &:before{
                width: 100%;
            }
        }
    }
}
</style>
